export default function selectionFilter({ series, films } = []) {
  return {
    series: [
      {
        title: 'Web Projects',
        data: series.filter((item) => item.genre === 'webProject'),
      },
      {
        title: 'Mobile Projects',
        data: series.filter((item) => item.genre === 'mobileProject'),
      },
      {
        title: 'Experiences :',
        data: series.filter((item) => item.genre === 'experiences'),
      },
      {
        title: 'Blog articles',
        data: series.filter((item) => item.genre === 'blog'),
      },
      {
        title: 'Hobbies',
        data: series.filter((item) => item.genre === 'hobbies'),
      },
    ],
    films: [
      { title: 'Drama', data: films.filter((item) => item.genre === 'drama') },
      {
        title: 'Thriller',
        data: films.filter((item) => item.genre === 'thriller'),
      },
      {
        title: 'Children',
        data: films.filter((item) => item.genre === 'children'),
      },
      {
        title: 'Suspense',
        data: films.filter((item) => item.genre === 'suspense'),
      },
      {
        title: 'Romance',
        data: films.filter((item) => item.genre === 'romance'),
      },
    ],
  };
}
